module.exports = __webpack_public_path__ + "img/mq.6f69d900.svg";